
import { defineComponent, PropType } from '@vue/composition-api';
import { MyBetsStats } from '../../../../../types/sport';

export default defineComponent({
  name: 'BetStats',
  props: {
    stats: {
      type: Object as PropType<MyBetsStats>,
      required: true
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    },
    formatPrice(value: number): string {
      const val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
});
